import { TFunction } from 'i18next';
import * as yup from 'yup';
import { IDP_NAME_REGEX } from '../../utilities/constants';
import { RoleMapper } from '../../models/IdpModels';

export const IdpFormValidationSchema = (t: TFunction): yup.ObjectSchema<any> =>
  yup.object().shape({
    id: yup.string(),
    name: yup.string(),
    displayName: yup
      .string()
      .required(t('Identity Provider Name is a required field'))
      .matches(
        IDP_NAME_REGEX,
        t('Name must be 3-32 characters long and can only contain letters, numbers or one of the following: . : / -')
      ),
    // TODO: AMP-651 validation required for rolemappers
    roleMappers: yup
      .object()
      .test(
        'missing_value',
        'Role Claim and Value fields are required',
        (roleMappers: { [key: string]: RoleMapper } | undefined) => {
          if (!roleMappers) {
            return true;
          }
          const invalidRoleMapper = Object.values(roleMappers).find((roleMapper) => {
            return !roleMapper.key || !roleMapper.value;
          });
          return !invalidRoleMapper;
        }
      ),
    samlMetadataUrl: yup.string().when('samlMetadataFile', {
      is: (samlMetadataFile: string) => !samlMetadataFile,
      then: yup.string().required(t('Either a Metadata URL or Metadata File must be provided')),
    }),
    domainNames: yup.array().test('not_empty', t('At least one Sign In Email Domain must be provided'), (domains) => {
      return (domains as string[]).length > 0;
    }),
    emailAttributeName: yup.string().required(t('Email Address attribute claim is a required field')),
    groupAttribute: yup.string().nullable(true),
    groupRoleMappings: yup.object().shape({
      admin: yup.string().nullable(true),
    }),
    enableTaniumConsoleAuth: yup.boolean().required(),
    enableAccountPortalAuth: yup.boolean().required(),
  });
